/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";
import TableDatePicker from "../components/runsheets/list/TableDatePicker";
import VehicleFilter from "../components/runsheets/list/VehicleFilter";

const RunsheetForm = props => {
  const {
    runsheet,
    handleRunsheetChange,
    handleDateChange,
    handleVehicleChange,
    errors
  } = props;
  const momentDate = moment(runsheet.scheduledAt);
  const vehicleId = runsheet.vehicle ? `${runsheet.vehicle.id}` : "";
  const externalIdClassNames = errors.includes("externalId")
    ? "form-control invalid"
    : "form-control";

  const nameClasses = errors.includes("name")
    ? "form-control invalid"
    : "form-control";

  return (
    <div>
      <Row className="bg-info-light">
        <Col xs={3}>
          <FormGroup controlId="externalId">
            <ControlLabel>Runsheet ID*</ControlLabel>

            <FormControl
              className={externalIdClassNames}
              name="externalId"
              onChange={handleRunsheetChange}
              placeholder="Runsheet ID"
              type="text"
              value={runsheet.externalId}
            />
          </FormGroup>
        </Col>

        <Col xs={3}>
          <FormGroup controlId="name">
            <ControlLabel>Name*</ControlLabel>
            <FormControl
              className={nameClasses}
              name="name"
              type="text"
              value={runsheet.name}
              placeholder="Name"
              onChange={handleRunsheetChange}
            />
          </FormGroup>
        </Col>

        <Col xs={3}>
          <label htmlFor="scheduledAt">Scheduled Date*</label>
          <div>
            <TableDatePicker date={momentDate} onChange={handleDateChange} />
          </div>
        </Col>

        <Col xs={3}>
          <label htmlFor="vehicle">Vehicle</label>
          <div>
            <VehicleFilter value={vehicleId} onChange={handleVehicleChange} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
RunsheetForm.propTypes = {
  runsheet: PropTypes.object.isRequired,
  handleRunsheetChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleVehicleChange: PropTypes.func.isRequired,
  errors: PropTypes.array
};
RunsheetForm.defaultProps = {
  errors: []
};

export default RunsheetForm;



// WEBPACK FOOTER //
// ./src/forms/RunsheetForm.js